import {IComponentController, IScope} from "angular";
import {Branch} from "../../model/Branch";

import './BranchListComponent.scss';
import {BranchesService} from "../../../branches_service/service/branches-service";
import {BranchesServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

interface BranchesListComponentScope extends IScope {
    branches: Branch[];
    deleteBranchCallback: (branch: Branch) => void;
}

export class BranchesListComponent implements IComponentController {

    public static instance = {
        template: require('./BranchesListComponent.html'),
        controller: [
            '$scope',
            '$mdDialog',
            BranchesServiceName,
            ToastNotificationServiceName,
            BranchesListComponent
        ],
        bindings: {
            branches: '<',
            brand: '<',
            deleteBranchCallback: '<'
        }
    };

    private $scope: BranchesListComponentScope;
    private branches: Branch[];
    private brand: string;

    constructor($scope: BranchesListComponentScope,
                private $mdDialog: angular.material.IDialogService,
                private branchService: BranchesService,
                private toastNotificationService: ToastNotificationService
    ) {
        this.$scope = $scope;
    }

    $onInit(): void {
        this.$scope.branches = this.branches;
        this.$scope.deleteBranchCallback = this.deleteBranch;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let branchesChanges = onChangesObj['branches'];
        if (branchesChanges && !branchesChanges.isFirstChange()) {
            this.$scope.branches = branchesChanges.currentValue;
        }
    }

    private deleteBranch = (branch: Branch) => {
        this.$scope.branches = this.$scope.branches.filter(b => b.branchName != branch.branchName);
    };

}